// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleNotesButton_deviceButton__T1kiP","icon":"ToggleNotesButton_icon__keOzB"};